// 1 - A, 2 - B, ...
export const serialNumberToChar = (num: number) => String.fromCharCode(64 + num);
